module.exports = __webpack_public_path__ + "media/visa.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/visa.png
// module id = 43
// module chunks = 0